import { render } from "./quanto.vue?vue&type=template&id=461b9a42&bindings={\"transitionName\":\"options\"}"
import script from "./quanto.vue?vue&type=script&lang=js"
export * from "./quanto.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./quanto.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script